import { render } from "./FotoOPD.vue?vue&type=template&id=311bed3e"
import script from "./FotoOPD.vue?vue&type=script&lang=js"
export * from "./FotoOPD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__